import clsx from 'clsx'
import { ITableProps } from './types'
import styles from './styles.module.scss'

const Table = ({
  className,
  tbodyCells,
  theadCells,
  tfootCells,
  size = 'md',
  transparent = false,
  hasBorder = true,
  hasBorderRadius = true,
  hasHoverEffect = true,
}: ITableProps) => {
  return (
    <div
      className={clsx(
        styles.wrap,
        { [styles.hasBorder]: hasBorder },
        { [styles.hasBorderRadius]: hasBorderRadius },
      )}
    >
      <table
        className={clsx(
          'mui-table',
          styles.table,
          styles[size],
          { [styles.transparent]: transparent },
          { [styles.hasHoverEffect]: hasHoverEffect },
          className,
        )}
      >
        {theadCells && <thead>{theadCells}</thead>}
        <tbody>{tbodyCells}</tbody>
        {tfootCells && <tfoot>{tfootCells}</tfoot>}
      </table>
    </div>
  )
}

export default Table
